<template>
  <div class="custom-card">

    <div class="image-preview-wrapper" @click="selectImage" @drop.prevent="filesDragged" @dragover.prevent>
      <span class="upload-hint" v-if="!previewImages.length">
        لطفا {{ title }} خود را انتخاب  کنید یا به داخل این باکس بیندازید
      </span>

      <v-row v-else-if="multiple" :class="['image-containers', multiple ? 'overflow-y-auto' : '']">
        <v-col v-for="(img, index) in previewImages"
               class="img-multiple-wrapper"
               :cols="multiple ? 4 : 12"
               :key="index">
          <img width="100%" :src="img" />
          <v-btn class="delete-btn" x-small fab color="#fb4e4e" @click.stop.prevent="deleteImage(index)">
            <v-icon color="white">mdi-trash-can</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <div v-else class="img-wrapper">
        <img class="single-image" :src="previewImages[0]" />
        <v-btn class="delete-btn" x-small fab color="#fb4e4e" @click.stop.prevent="deleteImage(0)">
          <v-icon color="white">mdi-trash-can</v-icon>
        </v-btn>
      </div>
    </div>

    <input
        style="display: none"
        accept="image/*"
        :multiple="multiple"
        ref="fileInput"
        type="file"
        @input="pickFile"/>
  </div>
</template>

<script>
export default {
  name: "ImageUploader",

  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'تصویر'
    },
    name: {
      type: String,
    }
  },


  data() {
    return {
      previewImages: []
    };
  },
  methods: {
    selectImage () {
      this.$refs.fileInput.click()
    },

    filesDragged(e) {
      let files = e.dataTransfer.files;
      this.makeImagesTiles(files)
    },

    pickFile () {
      let input = this.$refs.fileInput
      let files = input.files
      this.makeImagesTiles(files)
    },

    makeImagesTiles(files) {
      this.previewImages = [];
      if (files && files[0]) {
        let range = this.multiple ? files.length : 1
        for (let i = 0; i < range; i++) {
          let reader = new FileReader
          reader.onload = e => {
            this.previewImages.push(e.target.result)
          }
          reader.readAsDataURL(files[i])
        }

        this.emitBackToParent(files)
      }
    },

    emitBackToParent(files) {
      if (this.multiple) {
        this.$emit('filesReady', files, this.name)
      } else {
        this.$emit('filesReady', files[0], this.name)
      }
    },

    deleteImage(index) {
      this.previewImages.splice(index, 1);
    },

    reset() {
      this.previewImages = []
    }
  }
}
</script>

<style scoped>
.custom-card {
  border-radius: 12px;
  border: 1px dashed #EEEEEE;
}

.custom-card:hover {
  box-shadow: 0 5px 15px rgba(255, 255, 255, 0.1);
  transition: 0.5s ease;
}

.image-preview-wrapper {
  width: 100%;
  height: 250px;
  cursor: pointer;
}

.upload-hint {
  height: 100%;
  align-items: center;
  display: flex;
  text-align: center;
  padding: 10px;
  justify-content: center;
}

.image-containers {
  margin: 0;
  height: 100%;
}

.overflow-y-auto {
  overflow-y: auto;
}

img {
  border-radius: 12px;
}

.img-multiple-wrapper {
  display: flex;
  align-items: center;
  position: relative;
}

.img-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}

.img-wrapper > img {
  object-fit: contain;
  height: 100%;
  width: 100%;
}

.delete-btn {
  position: absolute;
  bottom: 15px;
  right: 15px;
}

.single-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 10px;
}
</style>
